import React, { useState, useEffect } from "react";

export default function ConsentModal({ onAgree, onDecline }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    document.body.classList.add("ai-consent-open");

    const declined = localStorage.getItem("dom_ai_consent_declined");
    if (declined === "true") {
      setSelectedOption("decline");
    }

    return () => {
      document.body.classList.remove("ai-consent-open");
    };
  }, []);

  const handleCheckboxChange = (option) => {
    setSelectedOption(option);
    setShowError(false);
  };

  const handleContinue = () => {
    if (!selectedOption) {
      setShowError(true);
      return;
    }

    if (selectedOption === "agree") {
      localStorage.removeItem("dom_ai_consent_declined");
      if (typeof window.removeAIOptOutUI === "function") window.removeAIOptOutUI();
      if (onAgree) onAgree();
    } else if (selectedOption === "decline") {
      localStorage.setItem("dom_ai_consent_declined", "true");
      if (typeof window.applyAIOptOutUI === "function") window.applyAIOptOutUI();
      if (onDecline) onDecline();
    }
  };

  // Authorable content defaults
  const wpData = window.DOM_CHAT_DATA || {};
  const consentTitle = wpData.consentTitle || "AI Data Consent Required";
  const consentBody = wpData.consentBody || "";
  return (
    <div className="chat-member-modal consent-modal-wrapper">
      <div className="chat-error modal-content modal-consent">
        <h1 className="consent-title">{consentTitle}</h1>

        <div
          className="consent-body"
          dangerouslySetInnerHTML={{ __html: consentBody }}
        />

        <div className="consent-options">
          <label>
            <input
              type="checkbox"
              checked={selectedOption === "agree"}
              onChange={() => handleCheckboxChange("agree")}
            />
            <span>I agree to the terms of the Atlas AI Assistant</span>
          </label>
          <label>
            <input
              type="checkbox"
              checked={selectedOption === "decline"}
              onChange={() => handleCheckboxChange("decline")}
            />
            <span>I decline use of the Atlas Assistant</span>
          </label>
          {showError && <div className="consent-error">Please select an option to proceed.</div>}
        </div>   

        <div>
          <button className="custom-button" onClick={handleContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}
